import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../assets/images/verify-ws.png'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "r2xl:!tw-max-w-[61%]" }, [
  /*#__PURE__*/_createTextVNode(" Wow, 🤩"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" that was quick! 🥳 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Looks like you have completed all necessary steps for your"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" workstation setup. If you are happy with all the details you"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" have provided then, submit your workstation for verification ")
], -1)
const _hoisted_5 = { class: "tw-grid tw-gap-4 tw-grid-cols-2 tw-w-full s540:!tw-flex s540:!tw-flex-col-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "600px",
    "max-width": "100%",
    className: ['setting_up_preview_modal']
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          icon: "mdi-close",
          class: "close_icon",
          onClick: $setup.onClickCloseButton
        }, null, 8, ["onClick"]),
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            onClick: $setup.onClickCloseButton,
            variant: "secondary",
            label: "Cancel"
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            onClick: $setup.onClickSubmitVerification,
            variant: "accent",
            label: "verify WORKSTATION"
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}